import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PushNotifications } from '@capacitor/push-notifications';
import { Device } from '@awesome-cordova-plugins/device/ngx';
import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';
import { Platform } from '@ionic/angular';
import { User } from '../../user/models/user';
import { NotificationFactory } from '../factories/notification-factory';
import { GlobalAppService } from 'src/app/services/global-app.service';
import { DeviceInfos } from 'src/app/models/device-infos';
import { FingerprintService } from 'src/app/services/fingerprint.service';
import { ApiProviderService } from 'src/app/services/api-provider.service';
import { DatabaseService } from 'src/app/services/database.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationPushService {
  
  version : string;
  env     : number;

  constructor(
    private device                    : Device,
    private readonly appVersion       : AppVersion,
    private readonly platform         : Platform,
    private readonly globalAppService : GlobalAppService,
    private readonly fingerprintServ  : FingerprintService,
    private readonly notifFactory     : NotificationFactory,
    private readonly apiProvider      : ApiProviderService,
    private readonly database         : DatabaseService
  ) {
      if(this.platform.is("capacitor")){
        this.env = this.globalAppService.getEnvironnement();
        this.appVersion.getVersionNumber().then(
          (version) => {
            this.version = version;
          }
        )
      }
   }


  addListeners(){
    
    
    if(this.platform.is("capacitor")){

      PushNotifications.removeAllListeners();
      
      PushNotifications.addListener('registration', async firebaseToken => {
        console.log(firebaseToken.value);
        await this.setUpFirebaseToken(firebaseToken.value);

      });


      PushNotifications.addListener('pushNotificationReceived', notification => {
        console.log(notification)
        let notif = this.notifFactory.create(notification.data);
        console.log(notif);
        notif.received();
      })
      

      PushNotifications.addListener('pushNotificationActionPerformed', notification => {
        console.log(notification)
        let notif = this.notifFactory.create(notification.notification.data);
        notif.perform();
      })


    }

  }

  async registerNotification(){
    if(this.platform.is("capacitor")){
      let permStatus = await PushNotifications.checkPermissions();

      if(permStatus.receive === 'prompt'){
        permStatus = await PushNotifications.requestPermissions();
      }
      if(permStatus.receive != 'granted'){
        throw new Error("User denied notification permission !")
      }
    }
  }

  private async setUpFirebaseToken(firebaseToken : string){

    let user : User = JSON.parse(localStorage.getItem("user"));

    if(firebaseToken && user?.id) {
      

      let firebaseLocalToken                = await this.database.getLocalFirebaseToken();

      let firebaseLocalTokenUserId          = localStorage.getItem('firebaseTokenUserId');
      let firebaseTokenInfo                 = new DeviceInfos();

      firebaseTokenInfo.firebaseToken = firebaseToken;
      firebaseTokenInfo.userId              = user?.id;
      firebaseTokenInfo.updateAt            = new Date();

      if(this.platform.is("capacitor")){
        await this.platform.ready();
        let uuid = await this.device.uuid;
        console.log(uuid);
        firebaseTokenInfo.deviceUUID        = uuid;
        firebaseTokenInfo.env               = this.env;
        firebaseTokenInfo.version           = this.version;
        firebaseTokenInfo.deviceType       = "PHONE"
        firebaseTokenInfo.deviceModel      = this.device.model;
      }else {
        firebaseTokenInfo.deviceUUID        = await this.fingerprintServ.getFingerprint();
        firebaseTokenInfo.deviceType       = "PC"
      }
        // If there is a firebase token il local
      if(firebaseLocalToken){
        // If the token is not the same from the localstorage, update it. Or dont do anything
        if(firebaseLocalToken != firebaseToken || firebaseLocalTokenUserId != user.id){
          this.apiProvider.updatefirebaseToken(firebaseTokenInfo).subscribe({
            next : async (response) => {
              console.log("Firebase token updated successfully");
              localStorage.setItem('firebaseTokenUserId', user.id);
              this.database.insertPhoneInfo(firebaseToken);
            }
            , error : (error) => {
              console.error("Error updating firebase token", error);
            }
          });
        }
      }
      else {

          this.apiProvider.createFirebaseToken(firebaseTokenInfo).subscribe({
            next : async (response) => {
              localStorage.setItem('firebaseTokenUserId', user.id);
              this.database.insertPhoneInfo(firebaseToken);
            }
            , error : (error) => {
              console.error("Error updating firebase token", error);
            }
          });
        
      }
    }

  }

}
